export enum DbOperation {
  Insert = 'Insert',
  Update = 'Update',
  Delete = 'Delete',
}
